import { IQuoteRespSchema, SigningOrderEnum } from '@monetize/types/app';

// called with contacts structure received on quote obj from API
export const calcEsignContactCounts = (quote: IQuoteRespSchema) => {
  const { contacts } = quote;
  const { esign: esignContacts } = contacts;
  let externalEsignContactCount = 0; // limiting these counts to 0 or 1 should be enforced by the API rather than needing to check it here
  let internalEsignContactCount = 0;
  esignContacts.forEach((contact) => {
    if (contact.internal) {
      internalEsignContactCount += 1;
    } else {
      externalEsignContactCount += 1;
    }
  });
  const hasOneInternalEsignContact = internalEsignContactCount === 1;
  const hasOneExternalEsignContact = externalEsignContactCount === 1;
  return { hasOneInternalEsignContact, hasOneExternalEsignContact };
};

export const getStandardContactsValidity = (
  quote: IQuoteRespSchema | undefined | null,
): { isValid: boolean; errorMsgs: string[] } => {
  const errorMsgs: string[] = [];
  if (!quote?.contacts.primary?.id) {
    errorMsgs.push('A shipping contact is required');
  }
  if (!quote?.contacts.billing?.id) {
    errorMsgs.push('A billing contact is required');
  }
  return {
    isValid: !errorMsgs.length,
    errorMsgs,
  };
};

export const getEsignContactValidity = (
  quote: IQuoteRespSchema | undefined | null,
): { isValid: boolean; errorMsgs: string[] } => {
  if (!quote?.requiresEsign) {
    return { isValid: true, errorMsgs: [] };
  }

  const { hasOneInternalEsignContact, hasOneExternalEsignContact } =
    calcEsignContactCounts(quote);

  const errorMsgs: string[] = [];

  if (
    quote.signingOrder !== SigningOrderEnum.EXTERNAL_ONLY &&
    !hasOneInternalEsignContact
  ) {
    errorMsgs.push(
      'To use eSign, one internal contact must be configured as a signer',
    );
  }

  if (!hasOneExternalEsignContact) {
    errorMsgs.push(
      'To use eSign, one external contact must be configured as a signer',
    );
  }

  return {
    isValid: errorMsgs.length === 0,
    errorMsgs,
  };
};
